import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/details/bulkUpdateDetailBillableStatus`;

export const ROUTE: RouteDefinition = `${baseRoute}/details/bulkUpdateDetailBillableStatus`;

export const URL = (): RouteDefinition => `${baseRoute}/details/bulkUpdateDetailBillableStatus`;
